<template>
  <a @click="$emit('click')" v-analytics="{label:'header_search'}">検索</a>
</template>

<script>
import analytics from '../../../directives/analytics';

export default {
  name      : 'search-button',
  directives: {
    analytics,
  },
};
</script>
